import { ADD_CHARACTER_LIST} from '../actions/action-types'

const defaultState = { characterList: []}

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_CHARACTER_LIST:
      return {
        ...state,
        characterList : action.response
      }
    
    default:
      return state
  }
}

export default reducer